import {Edge, MarkerType} from 'reactflow';

const SEQ_COLOR = '#9ca3af';
const LINK_COLOR = '#d1d5db';

const arrowMarker = (color: string): Edge['markerEnd'] => ({
    type: MarkerType.ArrowClosed,
    color,
    height: 18,
    width: 18,
});

export const ACTION_COLORS: Record<string, string> = {
    jump: '#377ea9',
    hide: '#da2c38',
    show: '#26a96c',
    block: '#9ca3af',
};

export function ruleEdgeStyleForModifier(modifier: string): Partial<Edge> {
    const color = ACTION_COLORS[modifier] ?? ACTION_COLORS.jump;
    return {
        type: 'bezier',
        className: `rf-rule-edge rf-rule-edge--${modifier}`,
        style: {stroke: color, strokeWidth: 2},
        markerEnd: arrowMarker(color),
        deletable: true,
    };
}

export function ghostEdgeStyleForModifier(modifier: string): Partial<Edge> {
    const color = ACTION_COLORS[modifier] ?? ACTION_COLORS.jump;
    return {
        type: 'bezier',
        className: `rf-ghost-edge rf-ghost-edge--${modifier}`,
        style: {stroke: color, strokeWidth: 1.5, strokeDasharray: '5 4', opacity: 0.5},
        markerEnd: arrowMarker(color),
        deletable: false,
        focusable: false,
        interactionWidth: 0,
    };
}

export const RULE_EDGE_STYLE: Partial<Edge> = ruleEdgeStyleForModifier('jump');

export const SEQ_EDGE_STYLE: Partial<Edge> = {
    type: 'smoothstep',
    style: {stroke: SEQ_COLOR, strokeWidth: 2},
    markerEnd: arrowMarker(SEQ_COLOR),
    deletable: false,
};

export const LINK_EDGE_STYLE: Partial<Edge> = {
    type: 'smoothstep',
    style: {stroke: LINK_COLOR, strokeWidth: 1.5, strokeDasharray: '4 3'},
    deletable: false,
};

export const GHOST_EDGE_STYLE: Partial<Edge> = ghostEdgeStyleForModifier('jump');
